import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { popupAjaxError } from "discourse/lib/ajax-error";
import DButton from "discourse/ui-kit/d-button";
import DModal from "discourse/ui-kit/d-modal";
import DModalCancel from "discourse/ui-kit/d-modal-cancel";
import { i18n } from "discourse-i18n";
import TopicAssignments from "../topic-assignments";

export default class EditTopicAssignments extends Component {
  @service taskActions;

  assignments = this.topic.assignments();

  get title() {
    if (this.topic.isAssigned() || this.topic.hasAssignedPosts()) {
      return i18n("edit_assignments_modal.title");
    } else {
      return i18n("discourse_assign.assign_modal.title");
    }
  }

  get topic() {
    return this.args.model.topic;
  }

  @action
  async submit() {
    this.args.closeModal();
    try {
      await this.#assign();
    } catch (error) {
      popupAjaxError(error);
    }
  }

  async #assign() {
    for (const assignment of this.assignments) {
      if (assignment.isEdited) {
        await this.taskActions.putAssignment(assignment);
      }
    }
  }

  <template>
    <DModal class="assign" @closeModal={{@closeModal}} @title={{this.title}}>
      <:body>
        <TopicAssignments
          @assignments={{this.assignments}}
          @onSubmit={{this.submit}}
        />
      </:body>
      <:footer>
        <DButton
          class="btn-primary"
          @action={{this.submit}}
          @label={{if
            this.model.reassign
            "discourse_assign.reassign.title"
            "discourse_assign.assign_modal.assign"
          }}
        />

        <DModalCancel @close={{@closeModal}} />
      </:footer>
    </DModal>
  </template>
}
